// extracted by mini-css-extract-plugin
module.exports = {"cardIcon":"card_cardIcon__2WCUu","cardTextDiv":"card_cardTextDiv__3lK8h","cardTitle":"card_cardTitle__3k_XO","cardNote":"card_cardNote__2wJsC"};